// services/subtitleStorageService.js
import { openDB } from "idb"; // کتابخونه idb رو نصب کنید: npm install idb

const DB_NAME = "SubtitleDB";
const DB_VERSION = 1;
const STORE_NAME = "subtitles";

let db = null;

const initDB = async () => {
  if (db) return db;

  db = await openDB(DB_NAME, DB_VERSION, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        const store = db.createObjectStore(STORE_NAME, { keyPath: "id" });
        store.createIndex("by-movieFileName", "movieFileName");
        store.createIndex("by-addedAt", "addedAt");
        store.createIndex("by-language", "language");
      }
    },
  });

  return db;
};

// ذخیره زیرنویس
export const saveSubtitle = async (subtitleData) => {
  const db = await initDB();

  const data = {
    id: `sub-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    ...subtitleData,
    addedAt: new Date().toISOString(),
    lastUsed: new Date().toISOString(),
    useCount: 1,
  };

  await db.add(STORE_NAME, data);
  return data.id;
};

// دریافت زیرنویس‌های یک فیلم خاص
export const getSubtitlesByMovie = async (movieFileName) => {
  const db = await initDB();
  const index = db.transaction(STORE_NAME).store.index("by-movieFileName");
  return await index.getAll(movieFileName);
};

// دریافت همه زیرنویس‌ها
export const getAllSubtitles = async () => {
  const db = await initDB();
  return await db.getAll(STORE_NAME);
};

// به‌روزرسانی lastUsed برای یک زیرنویس
export const updateSubtitleUsage = async (id) => {
  const db = await initDB();
  const tx = db.transaction(STORE_NAME, "readwrite");
  const store = tx.objectStore(STORE_NAME);

  const subtitle = await store.get(id);
  if (subtitle) {
    subtitle.lastUsed = new Date().toISOString();
    subtitle.useCount = (subtitle.useCount || 0) + 1;
    await store.put(subtitle);
  }

  await tx.done;
};

// حذف زیرنویس
export const deleteSubtitle = async (id) => {
  const db = await initDB();
  await db.delete(STORE_NAME, id);
};

// مدیریت حجم - حذف قدیمی‌ترین‌ها
export const evictOldestIfNeeded = async (
  maxItems = 300,
  maxSize = 25 * 1024 * 1024
) => {
  const db = await initDB();

  // چک کردن حجم کل
  const estimate = await navigator.storage.estimate();
  const totalUsed = estimate.usage || 0;

  if (totalUsed > maxSize) {
    await evictBySize(maxSize);
  }

  // چک کردن تعداد آیتم‌ها
  const allItems = await db.getAll(STORE_NAME);
  if (allItems.length > maxItems) {
    await evictByCount(maxItems);
  }
};

const evictBySize = async (maxSize) => {
  const db = await initDB();
  const estimate = await navigator.storage.estimate();
  const toFree = estimate.usage - maxSize;

  const allItems = await db.getAll(STORE_NAME);
  allItems.sort((a, b) => new Date(a.lastUsed) - new Date(b.lastUsed));

  const tx = db.transaction(STORE_NAME, "readwrite");
  let freed = 0;

  for (const item of allItems) {
    await tx.store.delete(item.id);
    freed += item.size || 0;
    if (freed >= toFree) break;
  }

  await tx.done;
};

const evictByCount = async (maxItems) => {
  const db = await initDB();
  const allItems = await db.getAll(STORE_NAME);

  if (allItems.length <= maxItems) return;

  allItems.sort((a, b) => new Date(a.lastUsed) - new Date(b.lastUsed));
  const toDelete = allItems.slice(0, allItems.length - maxItems);

  const tx = db.transaction(STORE_NAME, "readwrite");
  for (const item of toDelete) {
    await tx.store.delete(item.id);
  }
  await tx.done;
};
